import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'

import inlineStyles from './inlineStyles'
import Toolbar from '@client/components/Toolbar/index'
import IfIE from '@client/components/IfIE'
import {
  BlockModel,
  NULL as BlockModelNULL,
} from '@client/components/Block/model'
import TableInner from './TableInner'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'
import {
  BUTTON_BORDER_STYLES,
} from '@client/components/Editor/settings'

@inject('editor', 'serverRender')
@observer
class Table extends Component {
  static propTypes = {
    bgcolor: PropTypes.string,
    border: PropTypes.string,
    align: PropTypes.string,
    width: PropTypes.string,
    className: PropTypes.string,
    model: PropTypes.instanceOf(BlockModel),
    serverRender: PropTypes.bool,
    editor: PropTypes.instanceOf(EditorModel),
  }

  static defaultProps = {
    bgcolor: '',
    border: '0',
    align: 'center',
    width: '100%',
    className: 'section',
    model: BlockModelNULL,
    serverRender: false,
    editor: EditorModelNULL,
  }

  render() {
    const { model, editor, count } = this.props
    const { width, className } = this.props
    const settings = model.settings.values
    const backgroundColor = model.isFullWidth
      ? settings.backgroundColor || editor.settings.values.contentColor
      : ''
    const backgroundImage =
      model.isFullWidth && settings.hasBackgroundImage
        ? settings.backgroundImageUrl || ''
        : ''

    let tableCellStyles = {}

    if (backgroundImage) {
      tableCellStyles.backgroundPosition = 'center'
      tableCellStyles.backgroundSize = 'cover'
    }

    if (settings.borderStyle && settings.borderStyle !== BUTTON_BORDER_STYLES[0].value && model.isFullWidth) {
      tableCellStyles = { ...tableCellStyles, ...model.borderStyles, ...model.borderRadiusStyles }
    }

    return (
      <table
        className={className}
        role="presentation"
        cellSpacing="0"
        cellPadding="0"
        width={width}
        style={inlineStyles.table}
        border="0"
        align="center"
        ref={(el) => (this.dom = el)}
        // ref={this.props.refpass}
      >
        <tbody>
          <tr>
            <td
              style={tableCellStyles}
              align="center"
              background={backgroundImage}
              bgcolor={backgroundColor}
            >
              <Toolbar model={model} count={count} />
              <div
                className="webkit"
                style={{ maxWidth: '642px', margin: '0 auto' }}
              >
                <IfIE
                  browsers="(gte mso 9)|(IE)"
                  comment={
                    '<table role="presentation" cellspacing="0" cellpadding="0" border="0" width="642" align="center"><tr><td valign="top">'
                  }
                />

                <TableInner model={model} />

                <IfIE
                  browsers="(gte mso 9)|(IE)"
                  comment={'</td></tr></table>'}
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
}

export default Table
